import axios from '@/apis/axios';

class SigningList 
{
    static async getDocuments(process, status, companyProcessId = undefined)
    {
        const response = await axios.get(`/api/${process}/${status}/documents?filterByCompanyProcessId=${companyProcessId}`);

        return response.data;
    }

    static async getDocumentsToSign()
    {
        const response = await axios.get(`/api/documents`);

        return response.data.data;
    }

    static async getProcessDocuments(companyProcessId, documentId)
    {
        const response = await axios.get(`/api/${companyProcessId}/documents/${documentId}`);

        return response.data.data;
    }

    static async getDocumentContents(documentId)
    {
        const response = await axios.get(`/api/documents/${documentId}/contents`);

        return response.data.data;
    }

    static async getAllDocumentContents(companyProcessId, index)
    {
        const response = await axios.get(`/api/${companyProcessId}/documents/contents?index=${index}`);

        return response.data.data;
    }

    static async signDocuments(completeDocWithSignatures)
    {
        const response = await axios.post(`/api/documents/sign`, completeDocWithSignatures);

        return response.data.data;
    }

    static async getDocumentCount(process, companyProcessId = undefined)
    {
        const response = await axios.get(`/api/${process}/documents/count/all?filterByCompanyProcessId=${companyProcessId}`);

        return response.data.data;
    }

    static async termsOfService()
    {
        const response = await axios.get('/api/terms-of-service');

        return response.data;
    }

    static async download(process, documentIds)
    {
        const response = await axios.get(`/api/admin/${process}/download?documentIds=${documentIds}`);

        return response.data;
    }

    static async sendSignatureInvitationEmail()
    {
        // const response = await axios.post(`/api/admin/processes/${process}/send-signature-invitation-email`);
        const response = await axios.post('/api/admin/gmail-auth-url');

        return response.data;
    }

    static async requestGmailAuthUrl()
    {
        // const response = await axios.post(`/api/admin/processes/${process}/send-signature-invitation-email`);
        const response = await axios.get('/api/admin/gmail-auth-url');

        return response.data;
    }

    static async sendSignatureInvitationMail(data)
    {
        const response = await axios.post('/api/admin/send-signature-invitation-mail', data);

        return response.data;
    }

    static async makeGmailToken(code)
    {
        const response = await axios.get(`/api/admin/make-gmail-token?code=${code}`);

        return response.data;
    }
}

export default SigningList;